import { AttributesMixin, define, Model, type } from "@type-r/models";
import { fetchJson, restfulIO } from "api/endpoint";

export const root = '/api/v2/recs/';

export function fromStore<T extends typeof Model>( Type : T, collection : string, attr : string ){
    function getter( x, name ){
        return x || (
            this.attributes[ name ] = this.getStore()[ collection ].get( this[ attr ])
        )
    }

    function setter( x ){
        this.attributes[ attr ] = ( x && x.id ) || null;
        return x;
    }

    return type( Type ).value( undefined ).get( getter ).set( setter );
}

export async function execGetARBalance(supplierId, customerId, conversationIds) {
    const paramconversationIds = `conversationIds=${conversationIds.join("&conversationIds=")}`;
    const url = `${root}invoice/ar-balance?supplierId=${supplierId}&customerId=${customerId}&${paramconversationIds}`;
    return await fetchJson('GET', url);
}

export interface PlatformCompanyConfig extends AttributesMixin<typeof PlatformCompanyConfig> { }
@define
export class PlatformCompanyConfig extends Model {
    static endpoint = restfulIO('/api/pts/PlatformCompanyCustomerConfig');

    static attributes = {
        hasAutoBookPayments: Boolean,
        remittanceAdviceRequired: Boolean,
        reconciliationToleranceAmount: Number,
        reconciliationTolerancePercent: Number,
        recommendationToleranceAmount: type(Number).value(undefined),
        recommendationTolerancePercent: type(Number).value(undefined),
    };
}
